<template>
  <div id="app">
    <h1 class="app-title">智慧随行——视障人士室内辅助导航与信息获取系统</h1>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'App'
};
</script>


<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 0px;
}

.app-title {
  text-align: center;
  font-size: 32px;
  font-weight: bold;
  color: #ffffff;
  text-shadow: 0 0 2px #000000, 0 0 2px #000000, 0 0 2px #000000, 0 0 2px #000000;
  background-image: url('@/assets/image/header.png');
  background-size: cover;
  background-position: center;
  padding: 40px;
  margin: 20px 0;
  border-radius: 8px;
}
</style>
